import { useMemo } from 'react';
import { cratChain, tap2mineReferralContract } from 'shared';
import { useAccount, useReadContracts } from 'wagmi';

export const useReferralUserInfo = () => {
  const { address } = useAccount();

  const { data, isPending, isFetching, fetchStatus } = useReadContracts({
    contracts: [
      {
        abi: tap2mineReferralContract.abi,
        address: tap2mineReferralContract.address,
        functionName: 'uniqueReferralCount',
        args: [address!],
        chainId: cratChain.id,
      },
      {
        abi: tap2mineReferralContract.abi,
        address: tap2mineReferralContract.address,
        functionName: 'totalRewardAmount',
        args: [address!],
        chainId: cratChain.id,
      },
      {
        abi: tap2mineReferralContract.abi,
        address: tap2mineReferralContract.address,
        functionName: 'MAX_REWARD',
        chainId: cratChain.id,
      },
    ],
    query: {
      enabled: !!address,
    },
  });

  const isLoading = useMemo(
    () => (isPending && fetchStatus !== 'idle') || isFetching,
    [fetchStatus, isFetching, isPending],
  );

  return useMemo(
    () => ({
      isLoading,
      data: {
        uniqueReferralCount: data?.[0].result,
        totalRewardAmount: data?.[1].result,
        cpaRewardAmount: data?.[2].result,
      },
    }),
    [data, isLoading],
  );
};
